// extracted by mini-css-extract-plugin
export var base = "_55-0";
export var updateBanner = "_55-1";